import { useEffect } from 'react'
import { Link, NavLink } from 'react-router'
import { useSession } from '../session'
import { Mark } from './icons'

const ADMIN_NAV = [{ to: '/', label: 'Founders' }, { to: '/alerts', label: 'Alerts' }]

/** The top bar. The admin view by default; founders pass their own place name and links. */
export function Header({ showNav = true, where, home = '/', nav = ADMIN_NAV }: { showNav?: boolean; where?: string; home?: string; nav?: { to: string; label: string }[] }) {
  const s = useSession()
  useEffect(() => {
    document.title = where ? `cpg.computer · ${where}` : 'cpg.computer'
  }, [where])
  return (
    <header className="top">
      <div className="top-in">
        <Link className="wordmark" to={home} aria-label={where ? `cpg.computer ${where}` : 'cpg.computer'}>
          <Mark />
          <span className="wm-text">
            cpg<span className="pt">.</span>computer
          </span>
          {where && <span className="wm-where">{where}</span>}
        </Link>
        {showNav && (
          <nav className="top-nav" aria-label={where ?? 'Main'}>
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === '/'}>
                {n.label}
              </NavLink>
            ))}
          </nav>
        )}
        <div className="top-right">
          {s.mock && <span className="ex">Mock · Example data</span>}
          {s.email && <span className="who">{s.email}</span>}
          {s.isAuthenticated && (
            <button className="btn btn-ghost btn-sm" type="button" onClick={s.logout}>
              Sign out
            </button>
          )}
        </div>
      </div>
    </header>
  )
}
